import styled from "@emotion/styled";

export const PickerContainer = styled.div`
    position: relative;
    cursor: pointer;
`;